import { BASE_URL } from "../../App";
import CustomButton from "../Reusable/CustomButton";
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import axios from 'axios';
import Swal from 'sweetalert2';
import { Card } from 'antd';
import NoDataFound from '../image/NO_Data_Found.png';
import { Button, Backdrop, CircularProgress, FormControlLabel, TextField, Radio, RadioGroup, Dialog, DialogTitle, DialogContent, DialogActions, Stack, Autocomplete } from '@mui/material';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import ProductSelection from './ProductSelection.js';
import RemoveRedEyeRoundedIcon from '@mui/icons-material/RemoveRedEyeRounded';
import { SelectNormal, SelectSearch, MultipleSelect } from '../Reusable/SelectBox';

import ReportingModel from './ReportingModel';

export default function Home() {

    const focusRef = useRef(null);
    const navigate = useNavigate();
    const [value, setValue] = React.useState("Product");
    const [Oredrvalue, setOredrvalue] = React.useState(null);
    const [OrderType, setOrderType] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const [DealerDetail, setDealerDetails] = useState([]);
    const [dealer, setDealer] = useState([]);
    const [SerialNo, setSerialNo] = useState(null);
    const [FAQ, setFAQ] = useState(false);

	const [ProductDetails, setProductDetails] = useState({ PSG:null,ProductCode:null });
	const [psg, setPSG] = useState([]);
	const [ProductList, setProductList] = useState([]);
	const [selectedItem, setSelectedItem] = useState({ code: '', name: '' });
	const [selectedCode, setSelectedCode] = useState('');

	const [openModal, setOpenModal] = useState(false);

    // const location = useLocation();
    // useEffect(() => {
    //     const searchParams = new URLSearchParams(location.search);
    //     const id = searchParams.get('id');
    //     if (id) {
    //         alert(id);
    //     }
    // }, []);

    const login_id = localStorage.getItem("LOGIN_ID");

    const buttonStyle = {
        backgroundImage: 'linear-gradient(to right, #2e7fc2 0%, #6acad2 100%)',
    };

    useEffect(() => {
        DealerDetails();
        GetOrderType();
        PGSListLoad();
    }, []);

    const DealerDetails = () => {
        // if (dealerCode.trim() === '') {
        //     alert('Please enter a dealer code.');
        //     return;
        // }

        setOpen(true);
        const data = { type: 'DealerSearch', User_Id: login_id }
        axios.post(BASE_URL + '/siso', data)
            .then(response => {
                if (response.status === 200) {
                    if (response.data.message.length >= 1) {
                        setDealerDetails(response.data.message);
                    } else {
                        Swal.fire({
                            icon: "info",
                            text: 'Invalid Dealer!'
                        });
                        navigate('/Home');
                    }
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
            })
            .catch(error => {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: `Error: ${error.response.data.message}`
                    });
                    navigate('/Home/Spares/');
                } else if (error.request) {
                    navigate('/Home/Spares/');
                    console.error('No response received');
                } else {
                    console.error('Error setting up the request:', error.message);
                }
            }).finally(() => {
                setOpen(false);
            });
    };

    const GetOrderType = () => {
        setOpen(true);
        const data = { type: 'OrderTye' }
        axios.post(BASE_URL + '/siso', data)
            .then(response => {
                if (response.status === 200) {
                    if (response.data.message.length >= 1) {
                        setOrderType(response.data.message);
                    } else {
                        Swal.fire({
                            icon: "info",
                            text: 'Invalid Dealer!'
                        });
                        navigate('/Home');
                    }
                }
            })
            .catch(error => {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: error.response.data.message
                    });
                    // navigate('/Home/siso/');
                }
            }).finally(() => {
                setOpen(false);
            });
    }

    const SerialSearch = () => {

        const dealerInfo = DealerDetail.length === 1 ? DealerDetail[0] : dealer[0];

        if (!dealerInfo) {
            Swal.fire({
                icon: "info",
                text: 'Select Dealer !'
            });
        } else if (!Oredrvalue) {
            Swal.fire({
                icon: "info",
                text: 'Select Order Type !'
            });
        } else {
            setOpen(true);

            const data = { type: 'SerialSearch', Serial_No: SerialNo }
            axios.post(BASE_URL + '/siso', data)
                .then(response => {
                    if (response.data.message.length >= 1) {

                        navigate('/Home/Spares/Spares_Identification_Software/spare_selection', {
                            state: {
                                Dealer_Code: dealerInfo.DEALER_CODE,
                                Dealer_Name: dealerInfo.DEALERNAME,
                                Itemcode: response.data.message[0].MAT_CODE,
                                ITEMDESCRIPTION: response.data.message[0].ITEMDESCRIPTION,
                                Order_Type: Oredrvalue,
                            }
                        });

                    } else {
                        Swal.fire({
                            icon: "info",
                            text: 'Serial Number Not Match!.'
                        });
                    }
                })
                .catch(error => {
                    if (error.response) {
                        Swal.fire({
                            icon: "warning",
                            text: error.response.data.message
                        });
                    } else if (error.request) {
                        console.error('No response received');
                    } else {
                        console.error('Error setting up the request:', error.message);
                    }
                }).finally(() => {
                    setOpen(false);
                });
        }
    }

    const handleChange = (event) => {
        setValue(event.target.value);
    };

    const handleOrderTypeChange = (event) => {
        setOredrvalue(event.target.value);
    };

    const handleFAQClose = () => {
        setFAQ(false);
    };

    const HandleDealerChange = (newValue) => {
        if (newValue) {
            setOpen(true);
            const data = { type: 'DealerNameCode', User_Id: newValue }
            axios.post(BASE_URL + '/siso', data)
                .then(response => {
                    if (response.status === 200) {
                        if (response.data.message.length >= 1) {
                            setDealer(response.data.message);
                        } else {
                            Swal.fire({
                                icon: "info",
                                text: 'Invalid Dealer!'
                            });
                            navigate('/Home');
                        }
                    } else {
                        Swal.fire({
                            icon: "warning",
                            text: 'Unexpected response status. Please try again.'
                        });
                    }
                })
                .catch(error => {
                    if (error.response) {
                        Swal.fire({
                            icon: "warning",
                            text: `Error: ${error.response.data.message}`
                        });
                    } else if (error.request) {
                        console.error('No response received');
                    } else {
                        console.error('Error setting up the request:', error.message);
                    }
                }).finally(() => {
                    setOpen(false);
                });
        }
    }

    const DEALER_LIST = DealerDetail ? DealerDetail.map((type) => ({
        Value: type.DEALER_CODE,
        Label: type.DEALERNAME,
    })) : [];
	
    const PSG_LIST = psg ? psg.map((type) => ({
        Value: type.PSG_Code,
        Label: type.PSG_Name,
    })) : [];
	
    const Product_LIST = ProductList ? ProductList.map((type) => ({
        Value: type.Itemcode,
        Label: type.ITEMDESCRIPTION,
    })) : [];

	const PGSListLoad = () => {
        setOpen(true);
        const data = { type: 'ProductSubGroupNew' };
        axios.post(BASE_URL + '/siso', data)
            .then(response => {
                if (response.status === 200) {
                    setPSG(response.data.message);
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
            })
            .catch(error => {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: `Error: ${error.response.data.message}`
                    });
                } else if (error.request) {
                    console.error('No response received');
                } else {
                    console.error('Error setting up the request:', error.message);
                }
            }).finally(() => {
                setOpen(false);
            });
    };

	const PSGOnChange = (newValue) => {
		setProductDetails({ ...ProductDetails, PSG: newValue });
		
		if(newValue){
			setOpen(true);
			const data = { type: 'ProductNew',PSG_Code:newValue };
			axios.post(BASE_URL + '/siso', data)
			.then(response => {
				if (response.status === 200) {
					setProductList(response.data.message);
				} else {
					Swal.fire({
						icon: "warning",
						text: 'Unexpected response status. Please try again.'
					});
				}
			})
			.catch(error => {
				if (error.response) {
					Swal.fire({
						icon: "warning",
						text: `Error: ${error.response.data.message}`
					});
				} else if (error.request) {
					console.error('No response received');
				} else {
					console.error('Error setting up the request:', error.message);
				}
			}).finally(() => {
				setOpen(false);
			});
		}
	}
	
	const ViewBtnClick = () => {
        const dealerInfo = DealerDetail.length === 1 ? DealerDetail[0] : dealer[0];
		
		if (!ProductDetails.PSG) {
            Swal.fire({
                icon: "info",
                text: 'Select PSG !'
            });
        } else if (!selectedItem.code) {
            Swal.fire({
                icon: "info",
                text: 'Select Product !'
            });			
        }else if (!dealerInfo) {
            Swal.fire({
                icon: "info",
                text: 'Select Dealer !'
            });
        } else if (!Oredrvalue) {
            Swal.fire({
                icon: "info",
                text: 'Select Order Type !'
            });
        } else {
			
      console.log('Selected Product:', selectedItem);
			
            navigate('/Home/Spares/Spares_Identification_Software/spare_selection', {
				state: {
					Dealer_Name: dealerInfo.DEALERNAME,
					Dealer_Code: dealerInfo.DEALER_CODE,
					Itemcode: selectedItem.code,
					ITEMDESCRIPTION: selectedItem.name,
					Order_Type: Oredrvalue,
				}
			});
        }
	}

	const handleProductChange = (newValue) => {
		const selectedValue = newValue;
		setSelectedCode(selectedValue);

		const selectedProduct = Product_LIST.find((item) => item.Value === selectedValue);
		if (selectedProduct) {
			setSelectedItem({ ...ProductDetails, code: selectedProduct.Value, name: selectedProduct.Label });
		}
	};
	
	const handleOpenModal = () => {
		setOpenModal(true);
	};

	const handleCloseModal = () => {
		setOpenModal(false);
	};

	const handleConfirmAction = () => {
		setOpenModal(false);
	};
	
	const Css = `		
		.glass-card {
			background: rgba(255, 255, 255, 0.5);
			border-radius: 10px;
			padding: 10px;
			backdrop-filter: blur(100px);
			-webkit-backdrop-filter: blur(100px);
			box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
			border: 1px solid rgba(255, 255, 255, 0.2);
		}

		body {
			background: url('https://mobile.cri.in/images/siso_bg_image/Spares%20Tree%20Concept1.png') no-repeat center center fixed;
			background-size: cover;
			height: 100vh;
			margin: 0;
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
		}
	`;
	
    return (
        <>
			<style>{Css}</style>
            <div className="m-4">
			{/* <Card className="shadow bg-white rounded"> */}
                <Card className="glass-card">
                    {/* <center><h1 style={{ fontWeight: '1000' }}><i>SPARES IDENTIFICATION SOFTWARE</i></h1></center>
                    <hr /> */}
                    {DealerDetail.length > 0 && (
                        <>
                            {DealerDetail.length === 1 ? (
                                <>
                                    <div className='row'>
                                        {/* <div className='col-md-6 mt-2'>
                                            <TextField label="Dealer Code" value={DealerDetail[0].DEALER_CODE} size="small" fullWidth />
                                        </div>
                                        <div className='col-md-6 mt-2'> */}
                                        {/* </div> */}
                                        <TextField label="Dealer Name" value={DealerDetail[0].DEALERNAME} size="small" fullWidth />
                                    </div>
                                </>
                            ) : (
                                <>
                                    <SelectSearch
                                        readOnly={true}
                                        label="Dealer Name"
                                        options={DEALER_LIST}
                                        value={dealer}
                                        size={"small"}
                                        onChange={(newValue) => HandleDealerChange(newValue)}
                                    />
                                </>
                            )}
                            <br />
                            <div className='row'>
                                <div className='col-md-6 mt-2'>
                                    <center><b>Product Details</b></center>
                                    <RadioGroup value={value} onChange={handleChange} row sx={{ justifyContent: 'center', textAlign: 'center' }} >
                                        <FormControlLabel value="Product" control={<Radio />} label={<b>Product</b>} />
                                        <FormControlLabel value="Serial No" control={<Radio />} label={<b>Serial No</b>} />
                                    </RadioGroup>
                                </div>
                                <div className='col-md-6 mt-2'>
                                    <center><b>Order Type</b></center>
                                    <RadioGroup value={Oredrvalue} onChange={handleOrderTypeChange} row sx={{ justifyContent: 'center', textAlign: 'center' }}>
                                        {OrderType && OrderType.map((ot, index) => (
                                            <FormControlLabel
                                                key={ot.order_type}
                                                value={ot.order_type}
                                                // control={<Radio />}
                                                control={<Radio inputRef={index === 0 ? focusRef : null} />}
                                                label={<b>{ot.order_type}</b>}
                                                disabled={ot.Active == 1 ? false : true}
                                            />
                                        ))}
                                    </RadioGroup>
                                </div>
                            </div>
                        </>
                    )}
					<img
						src="https://mobile.cri.in/images/siso_bg_image/Spares%201%20Icon.png"
						style={{
							width:"121px",
							marginTop:"10px",
							float:"right"
						}}
					/>
                </Card>
                <br />
                <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open} >
                    <CircularProgress color="inherit" />
                </Backdrop>
                {value === 'Serial No' && (
                    <Card className="glass-card">
                        <div className='row'>
                            <div className='col-md-8 mt-2'>
                                <TextField label="Serial Number" value={SerialNo} onChange={(e) => setSerialNo(e.target.value)} size="small" fullWidth />
                            </div>
                            <div className='col-md-4 mt-2'>
                                <Button fullWidth variant="contained" endIcon={<RemoveRedEyeRoundedIcon />} onClick={SerialSearch} style={buttonStyle} ><b>View</b></Button>
                            </div>
                        </div>
                    </Card>
                )}
                {value === 'Product' && (
                    <Card className="glass-card">
					
					<div className="row">
						<div className="col-md-6 mt-2">
							<SelectSearch
								label="Product Sub Group"
								options={PSG_LIST}
								size={"small"}
								value={ProductDetails.PSG}
								onChange={PSGOnChange}
								// onChange={(newValue) => setProductDetails({ ...ProductDetails, PSG: newValue })}
							/>
						</div>
						<div className="col-md-6 mt-2">
							<SelectSearch
								label="Product"
								options={Product_LIST}
								size={"small"}
								value={selectedCode}
								onChange={handleProductChange}
								// onChange={(newValue) => setProductDetails({ ...ProductDetails, ProductCode: newValue })}
							/>
						</div>
						<div className="col-md-12 mt-2">
							<Button
								fullWidth
								variant="contained"
								endIcon={<RemoveRedEyeRoundedIcon />}
								onClick={ViewBtnClick}
								style={buttonStyle}
							>
								<b>View</b>
							</Button>
						</div>
					</div>
					
					{/*
						{DealerDetail.length === 1 ? (
                            <>
                                <ProductSelection
                                    DealerName={DealerDetail.length > 0 ? DealerDetail[0].DEALERNAME : ''}
                                    DealerCode={DealerDetail.length > 0 ? DealerDetail[0].DEALER_CODE : ''}
                                    Order_Type={Oredrvalue}
                                />
                            </>
                        ) : (
                            <>
                                <ProductSelection
                                    DealerName={dealer.length > 0 ? dealer[0].DEALERNAME : ''}
                                    DealerCode={dealer.length > 0 ? dealer[0].DEALER_CODE : ''}
                                    Order_Type={Oredrvalue}
                                />
                            </>
                        )}
					*/}
                    </Card>
                )}
                <br />
                <Card className="glass-card">
					<Button onClick={() => setFAQ(true)} endIcon={<ContactSupportIcon />} fullWidth variant="contained" style={buttonStyle} ><b>FAQ..</b></Button>
					<br/>
					<br/>
					<Button onClick={handleOpenModal} fullWidth variant="contained" style={buttonStyle} ><b>Report an Issue </b></Button>
                </Card>
                {FAQ && (
                    <FAQPopup onClose={handleFAQClose} />
                )}
				
				<ReportingModel
					ModelOpen={openModal}
					onClose={handleCloseModal}
				/>
            </div>
        </>
    );
};

const FAQPopup = ({ data, onClose }) => {
    return (
        <Dialog open={true} onClose={onClose} maxWidth="sm" fullWidth sx={{ justifyContent: 'center' }}>
            <DialogTitle><center><u><b>FAQ</b></u></center></DialogTitle>
            <DialogContent>
			{/*<div className="text-muted h2"><center>No Data Found!</center></div> */}
			<br />
			<center>
				<img src={NoDataFound} alt={""} style={{ width: '100px' }} />
				<h5 style={{ fontWeight: '700' }}><i>No data available</i></h5>
			</center>
			<br />
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center' }}>
                <Stack sx={{ width: '100%', maxWidth: '400px' }}>
                    <CustomButton
                        label="Cancel"
                        onClick={onClose}
                        variant="outlined"
                        color="error"
                        fullWidth
                    />
                </Stack>
            </DialogActions>
        </Dialog>
    );
}